import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import { Controller, useFormContext } from 'react-hook-form';
import PartOfCrpComboBox from '../../PartOfCrpComboBox';

const PartOfCrpForm: FC = () => {
  const t = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <Stack>
        <Text textStyle="Heading.S" tagName="h4">
          {t('labels.countryRetailPlan')}
        </Text>
      </Stack>
      <Stack mt={1} mb={2}>
        <span className={'form-field__character-limit form-field__message'}>
          {t('projects.crpDescription')}
        </span>
      </Stack>
      <Controller
        name={'partOfCrp'}
        control={control}
        render={({ field: { onChange, value } }) => (
          <PartOfCrpComboBox
            key={value?.length}
            partOfCrp={value}
            handleUpdate={onChange}
          />
        )}
      />
    </>
  );
};

export default PartOfCrpForm;
